import React from 'react';
import './Cart.css';

const Cart = (props) => {
    const {cart} = props;
    let total = 0;
    let name = [];
    for(const product of cart) {
        total = total + product.price;
        name = name + product.name;
    }
    return (
        <div>
            <h3>ORDER SUMMARY</h3>
               <h5>ITEMS ORDER: {props.cart.length}</h5>
               <h5>TOTAL COST : $ {total}</h5>
               <h5>{name}</h5>

        </div>
    );
};

export default Cart;